"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductMeasuresFilter = exports.getProductTextAttributesFilter = exports.PRODUCT_BASE_ATTRIBUTES_FILTER = exports.generateProductFilter = exports.createProductPresentationAttributesFilter = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const table_filter_shared_utils_1 = require("../../../client/product/hooks/table-filter-shared.utils");
const attributes_1 = require("../../../constants/attributes");
// enriched data - text attributes
const createProductPresentationAttributesFilter = (attributeName, filter, includeAttributeStatuses = true) => {
    var _a, _b, _c, _d;
    const statusFilter = includeAttributeStatuses
        ? { status: { in: [graphql_1.ProductAttributeStatus.InStrategy, graphql_1.ProductAttributeStatus.Valid] } }
        : {};
    const labelFilter = { label: { equals: attributeName } };
    const noneFilter = {
        labels: {
            none: Object.assign(Object.assign({}, labelFilter), statusFilter),
        },
    };
    if (filter.selectAll) {
        const excluded = (_a = filter.excludedValues) !== null && _a !== void 0 ? _a : [];
        const isUnknownExcluded = excluded.includes(attributes_1.SpecialAttributeValue.Unknown);
        const excludedWithoutUnknown = excluded.filter((v) => v !== attributes_1.SpecialAttributeValue.Unknown);
        const someFilter = {
            labels: {
                some: Object.assign(Object.assign(Object.assign({}, labelFilter), statusFilter), (excludedWithoutUnknown.length > 0 && { value: { notIn: excludedWithoutUnknown } })),
            },
        };
        if (isUnknownExcluded) {
            return someFilter;
        }
        // Unknown is not excluded — include products with no value (Unknown) alongside known values
        return {
            labels: Object.assign(Object.assign({}, someFilter.labels), noneFilter.labels),
        };
    }
    const hasUnknown = (_b = filter.list) === null || _b === void 0 ? void 0 : _b.includes(attributes_1.SpecialAttributeValue.Unknown);
    const realValues = (_d = (_c = filter.list) === null || _c === void 0 ? void 0 : _c.filter((v) => v !== attributes_1.SpecialAttributeValue.Unknown)) !== null && _d !== void 0 ? _d : [];
    // Only Unknown selected
    if (hasUnknown && realValues.length === 0) {
        return noneFilter;
    }
    const someFilter = {
        labels: {
            some: Object.assign(Object.assign(Object.assign({}, labelFilter), statusFilter), (realValues.length > 0 && { value: { in: realValues } })),
        },
    };
    // Unknown + real values: combine some + none per BE API
    if (hasUnknown && realValues.length > 0) {
        return {
            labels: Object.assign(Object.assign({}, someFilter.labels), noneFilter.labels),
        };
    }
    return someFilter;
};
exports.createProductPresentationAttributesFilter = createProductPresentationAttributesFilter;
/** @deprecated use generatePresentationAwareProductFilter */
const generateProductFilter = (tableFilter, includeAttributeStatuses = true) => (0, table_filter_shared_utils_1.buildBaseProductFilterFromTableFilter)(tableFilter, (fieldKey, filterData) => (0, exports.createProductPresentationAttributesFilter)(fieldKey, filterData, includeAttributeStatuses));
exports.generateProductFilter = generateProductFilter;
exports.PRODUCT_BASE_ATTRIBUTES_FILTER = [{ label: { in: attributes_1.BASE_ENRICHED_ATTRIBUTES } }];
const getProductTextAttributesFilter = (excludedColumns, selectAllMode) => {
    const excludedLabelColumnsWithoutCustomFields = (0, ramda_1.without)(Object.values(attributes_1.CustomProductAttributes), excludedColumns);
    if (!excludedLabelColumnsWithoutCustomFields.length) {
        return null;
    }
    const filters = [];
    filters[0] = {
        label: (!selectAllMode
            ? { in: (0, ramda_1.uniq)([...excludedLabelColumnsWithoutCustomFields, ...attributes_1.BASE_ENRICHED_ATTRIBUTES]) }
            : { notIn: excludedLabelColumnsWithoutCustomFields }),
    };
    return filters;
};
exports.getProductTextAttributesFilter = getProductTextAttributesFilter;
const getProductMeasuresFilter = (excludedColumns, selectAllMode) => {
    if (!excludedColumns.length) {
        return undefined;
    }
    return { dimension: (!selectAllMode ? { in: excludedColumns } : { notIn: excludedColumns }) };
};
exports.getProductMeasuresFilter = getProductMeasuresFilter;
